import { AnswerCommand } from 'core/commands/elements/answers/answer.abstract.command';
import { tactileoAnswersDTOTypes } from 'utils/activityItem.util';

export class PollQuestionAnswerCommand extends AnswerCommand {
  constructor(pollQuestion) {
    super(tactileoAnswersDTOTypes.POLL_QUESTION, pollQuestion);
    this.selected_choices = pollQuestion.selectedChoices;
  }
}
